import {MessageBox} from "mint-ui";

const mutations = {

  //页面跳转
  naveTo(state, param){
    if(param.hasOwnProperty('param')){
      param.vue.$router.push({name:param.path, params: {'detail': param.param}})
    }else{
      if(param.vue && param.vue.$router){
        param.vue.$router.push(param.path)
      }
    }
  },

  onBack(state, router) {
    if(window.client.ios){
      state.showLeaveAnim = true
    }
    router.back()
  },

  //设置页面标题
  setTitle(state, name){
    state.title = name
  },

  //登录成功回调
  onLoginSuccess(state, data){
    // console.log((state.ctx))
    state.logined = true
    console.log(JSON.stringify(data))
    state.ctx.$info.parse(state, data)

    console.log(' onLoginSuccess   ' + JSON.stringify(state.ctx.$info))

    let self = this

    if(state.uinfo.type == 1){
      this.$http_data.guest_info_get(function (data) {
        state.ctx.$info.parse(state, data)
        self.commit('getWelcomePacket')
      })
    }else{
      this.$http_data.infoGet(function (data) {
        state.ctx.$info.parse(state, data)
        self.commit('getWelcomePacket')
      })
    }

    if(state.currentVue != null && state.currentVue.onLoginOK){
      state.currentVue.onLoginOK()
    }
  },

  getWelcomePacket(state){
    let self = this
    var i=3
    if(!state.ctx.$info.firstWeal){
      this.$http_data.rpWelcomeGet(function (welcomeData) {
        /*var timerS=setInterval(function () {*/
        /*  i--;
          if(i<0){*/
            self.commit('naveTo', {vue: state.ctx, path: state.ctx.$router_path.systemRPDetail, param: welcomeData})
            /*window.clearInterval(timerS);*/
         /* }*/
    /*    },3000)*/

      })
    }
  },


  showTipDialog(state, setup){

    state.ctx.$messagebox({
      title: '提示',
      message: setup.msg,
      confirmButtonText: '知道了'
    })
  },

  deleteTipDialog(state, setup){
    // let arr = state.ctx.tipDialog
    // for(let i=0; i<arr.length; i++) {
    //   if(arr[i] == setup) {
    //     arr.splice(i, 1);
    //     break;
    //   }
    // }
  },

  showLoadingBar(state, setup){
    // let arr = state.ctx.tipLoading
    // arr.push(setup)
  },

  deleteLoadingBar(state, setup){
    if(setup != null){
      let arr = state.ctx.tipLoading
      if(arr != null){
        for(let i=0; i<arr.length; i++) {
          if(arr[i] == setup) {
            arr.splice(i, 1);
            break;
          }
        }
      }
    }
  },

  clearLoadingBar(state){
    state.ctx.tipLoading = []
  },

  showToastNormal(state, msg){
    this.commit('showToast', {msg: msg})
  },
  showToast(state, setup){
    state.ctx.$toast({message: setup.msg,
      position: 'bottom',
      duration: 2000})

  },

}

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js